module.exports = __webpack_public_path__ + "media/images/newsletter-logo-4a8d4970ee981decf43eff34a7447912.gif";